import axios from 'axios'
import { Constants } from '../utils/constants'
import { showMessage } from '../utils/alerts'

// Prevent repeated error popups
let errorFlag = true
let sessionFlag = true

// Create axios instance
const api = axios.create({
  baseURL: Constants.URL.base,
  withCredentials: true, // 🔥 REQUIRED for Liferay cookies
  headers: {
    'Content-Type': 'application/json'
  }
})

// Helper to get p_auth safely
const getPAuth = () => {
  return window?.Liferay?.authToken || null
}

//  REQUEST INTERCEPTOR
api.interceptors.request.use(
  (request) => {
    const pAuth = getPAuth()

    if (pAuth) {
      // Preferred header
      request.headers['x-csrf-token'] = pAuth

      // Optional fallback (some APIs expect this)
      request.params = {
        ...(request.params || {}),
        p_auth: pAuth
      }
    }

    return request
  },
  (error) => Promise.reject(error)
)

//  RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => {
    errorFlag = true
    sessionFlag = true
    return response
  },
  (error) => {
    const status = error.response ? error.response.status : null

    if (status === 500) {
      if (errorFlag) {
        showMessage('Something went wrong', 'Please try again later!')
        errorFlag = false
      }
    }

    if (status === 403) {
      if (errorFlag) {
        showMessage('Access Denied', 'You do not have permission.')
        errorFlag = false
      }
    }

    if (status === 404) {
      if (errorFlag) {
        showMessage('Not Found', 'Requested resource not found.')
        errorFlag = false
      }
    }

    if (status === 401) {
      if (sessionFlag) {
        showMessage('Session Expired', 'Please login again.')
        sessionFlag = false
      }

      //  Redirect to Liferay login
      window.location.href = '/c/portal/login'
    }

    return Promise.reject(error)
  }
)

export { api }